export const menuItems = [
  {
    id: 1,
    category: "Pizza",
    name: "Margherita Classica",
    description: "San Marzano tomato, fresh mozzarella, basil, extra virgin olive oil",
    price: "2,490 ISK",
    tag: "Classic",
    image: "https://public.readdy.ai/ai/img_res/ecfe08710bc6a57526500812055c36f5.jpg",
  },
  {
    id: 2,
    category: "Pizza",
    name: "Volcano Special",
    description: "Spicy salami, roasted peppers, jalapeños, smoked mozzarella, chili oil",
    price: "2,890 ISK",
    tag: "Traveler Favorite",
    image: "https://readdy.ai/api/search-image?query=spicy%20salami%20pizza%20with%20roasted%20peppers%20and%20melted%20cheese%2C%20dramatic%20warm%20lighting%2C%20dark%20rustic%20background%2C%20artisan%20pizza%2C%20food%20photography&width=400&height=300&seq=pizza2&orientation=landscape",
  },
  {
    id: 3,
    category: "Pizza",
    name: "South Coast",
    description: "Smoked salmon, cream cheese, capers, red onion, dill, lemon zest",
    price: "3,190 ISK",
    tag: "Signature",
    image: "https://readdy.ai/api/search-image?query=smoked%20salmon%20pizza%20with%20cream%20cheese%20and%20fresh%20dill%20on%20artisan%20crust%2C%20warm%20golden%20lighting%2C%20dark%20background%2C%20gourmet%20food%20photography&width=400&height=300&seq=pizza3&orientation=landscape",
  },
  {
    id: 4,
    category: "Pizza",
    name: "Highland Lamb",
    description: "Slow-roasted Icelandic lamb, rosemary, garlic, feta, sun-dried tomatoes",
    price: "3,490 ISK",
    tag: "Chef's Pick",
    image: "https://readdy.ai/api/search-image?query=lamb%20pizza%20with%20rosemary%20and%20feta%20cheese%20on%20rustic%20artisan%20crust%2C%20warm%20dramatic%20lighting%2C%20dark%20wooden%20background%2C%20gourmet%20food%20photography&width=400&height=300&seq=pizza4&orientation=landscape",
  },
  {
    id: 5,
    category: "Burgers",
    name: "Gallery Burger",
    description: "Beef patty, cheddar, caramelized onions, pickles, house sauce, brioche bun",
    price: "2,690 ISK",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=gourmet%20beef%20burger%20with%20cheddar%20and%20caramelized%20onions%20on%20brioche%20bun%2C%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20food%20photography&width=400&height=300&seq=burger1&orientation=landscape",
  },
  {
    id: 6,
    category: "Fish & Chips",
    name: "Icelandic Fish & Chips",
    description: "Fresh Atlantic cod, crispy beer batter, hand-cut fries, tartar sauce, lemon",
    price: "2,990 ISK",
    tag: "Local Favorite",
    image: "https://readdy.ai/api/search-image?query=crispy%20beer%20battered%20fish%20and%20chips%20with%20tartar%20sauce%20and%20lemon%2C%20warm%20golden%20lighting%2C%20rustic%20dark%20background%2C%20food%20photography&width=400&height=300&seq=fish1&orientation=landscape",
  },
  {
    id: 7,
    category: "Salads",
    name: "Crossroads Salad",
    description: "Mixed greens, cherry tomatoes, cucumber, feta, olives, house vinaigrette",
    price: "1,990 ISK",
    tag: "",
    image: "https://readdy.ai/api/search-image?query=fresh%20garden%20salad%20with%20feta%20cheese%20and%20olives%20in%20rustic%20bowl%2C%20warm%20lighting%2C%20dark%20background%2C%20healthy%20food%20photography&width=400&height=300&seq=salad1&orientation=landscape",
  },
  {
    id: 8,
    category: "Lamb Chops",
    name: "Icelandic Lamb Chops",
    description: "Grilled Icelandic lamb chops, herb butter, roasted vegetables, mint sauce",
    price: "4,490 ISK",
    tag: "Premium",
    image: "https://readdy.ai/api/search-image?query=grilled%20Icelandic%20lamb%20chops%20with%20herb%20butter%20and%20roasted%20vegetables%2C%20dramatic%20warm%20lighting%2C%20dark%20rustic%20background%2C%20premium%20food%20photography&width=400&height=300&seq=lamb1&orientation=landscape",
  },
];

export const reviews = [
  {
    id: 1,
    name: "Sarah M.",
    origin: "United States",
    text: "Unexpectedly amazing pizza! We stopped here on our way to Seljalandsfoss and it was the highlight of our day. The crust is perfect and the atmosphere with the art on the walls is so unique.",
    rating: 5,
    source: "Google Review",
  },
  {
    id: 2,
    name: "Thomas K.",
    origin: "Germany",
    text: "Perfect stop before heading to the Highlands. The Highland Lamb pizza is absolutely incredible — you can taste the quality of the local ingredients. Will definitely stop again on our way back.",
    rating: 5,
    source: "TripAdvisor",
  },
  {
    id: 3,
    name: "Emma L.",
    origin: "United Kingdom",
    text: "Great food and cool gallery atmosphere. The fish and chips were some of the best I've had in Iceland. Friendly staff and quick service — exactly what you need on a road trip!",
    rating: 5,
    source: "Google Review",
  },
  {
    id: 4,
    name: "Jón Sigurðsson",
    origin: "Iceland",
    text: "Our local favorite. The pizza quality is consistently excellent and the portions are generous. Love that they support local Icelandic ingredients. A true gem at Landvegamót.",
    rating: 5,
    source: "Google Review",
  },
];

export const nearbyAttractions = [
  {
    name: "Caves of Hella",
    distance: "",
    description: "",
    icon: "ri-water-flash-line",
  },
  {
    name: "Landmannalaugar",
    distance: "",
    description: "",
    icon: "ri-landscape-line",
  },
  {
    name: "Hekla Volcano",
    distance: "45 min",
    description: "Iceland's most active volcano",
    icon: "ri-fire-line",
  },
  {
    name: "South Coast",
    distance: "1 hour away",
    description: "Black sand beaches & glaciers",
    icon: "ri-map-pin-line",
  },
  {
    name: "Landeyjahöfn",
    distance: "40 min",
    description: "40 minutes from Landvegamót",
    icon: "ri-ship-line",
  },
];

export const stopFeatures = [
  {
    icon: "ri-car-line",
    title: "Free Parking",
    description: "Pull right off Route 1 — spacious parking for cars, campervans & buses",
  },
  {
    icon: "ri-time-line",
    title: "Quick Service",
    description: "Fresh pizza ready in minutes — no long waits on your road trip",
  },
  {
    icon: "ri-cup-line",
    title: "Beers & Drinks",
    description: "Full beverage menu including beers, soft drinks & local favorites",
  },
  {
    icon: "ri-map-2-line",
    title: "Perfect Location",
    description: "Midway between the Highlands, South Coast & Seljalandsfoss",
  },
];
